import React from "react"

// Mui
import { Box, Container, Grid, Stack, styled, Tooltip, Typography, useTheme } from "@mui/material"

// Next Image
import Image from "next/image"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"

// Images

import NoImage from "public/noImages.png"
import Link from "next/link"
import { useIsMobileHandler } from "../../../../../hooks/useIsMobileHandler"

import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/swiper-bundle.min.css"
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper"
import { useRouter } from "next/router"
import axios from "../../../../../lib/axios"

// ---------------------------------------------------------------------------------------------------------------------

export default function Acceptors({ merchantData }) {
  // Use Theme
  const router = useRouter()
  const theme = useTheme()

  const isMobile = useIsMobileHandler()

  // Data

  const handleRouteToMerchantDetails = itemId => {
    router.push(`merchantDetails/${itemId.id}`)
  }
  if (!isMobile) {
    return (
      <Container sx={{ mt: 10, mb: 6, pb: 2 }} id='acceptors'>
        <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
          <Typography
            variant='h3'
            fontWeight='bold'
            mb={"30px"}
            sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}
          >
            شبکه پذیرندگان
          </Typography>
        </Stack>
        <Stack
          direction='row'
          justifyContent='center'
          alignItems='center'
          spacing={1}
          height={"15rem"}
          borderRadius={"1rem"}
          bgcolor={theme.palette.common.white}
        >
          <Swiper
            slidesPerView={5}
            spaceBetween={30}
            pagination={{
              clickable: true
            }}
            modules={[Pagination, Navigation, Scrollbar, A11y, Autoplay]}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false
            }}
            loop={true}
            style={{ width: "100%" }}
          >
            {merchantData?.map((item, index) => (
              <SwiperSlide key={index} onClick={() => handleRouteToMerchantDetails(item)}>
                <Box sx={{ mx: 1, p: 0, cursor: "pointer", position: "relative" }} className='providers_image'>
                  <Tooltip title={item.name} sx={{ zIndex: 1000 }}>
                    <span style={{ display: "block" }}>
                      <Image width='200' height='150' src={item.file ?? NoImage.src} alt={item.name} />
                    </span>
                  </Tooltip>
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Stack>
        <Stack direction='row' justifyContent='flex-end' alignItems='center' spacing={1} marginTop={"2rem"}>
          <Typography variant='h5' fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
            <Link href='/merchant'>نمایش بیشتر ...</Link>
          </Typography>
        </Stack>
      </Container>
    )
  } else {
    return (
      <Box sx={{ mt: 10 }} id='mobileAcceptors'>
        <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
          <Typography variant='h4' fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
            شبکه پذیرندگان
          </Typography>
        </Stack>
        <Box mt={10} bgcolor={theme.palette.common.white} borderRadius={"1rem"} margin={"1rem 1rem"} padding={"1rem"}>
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false
            }}
            pagination={true}
            modules={[Autoplay]}
          >
            {merchantData?.map((item, index) => (
              <SwiperSlide key={index} onClick={() => handleRouteToMerchantDetails(item)}>
                <Box
                  sx={{ mx: 1, p: 0, cursor: "pointer", height: "18rem", position: "relative" }}
                  className='providers_image'
                >
                  <Tooltip title={item.name} sx={{ zIndex: 1000 }}>
                    <span style={{ display: "block", textAlign: "center" }}>
                      <Typography
                        variant='h5'
                        sx={{
                          position: "absolute",
                          bottom: 10,
                          left: 10,
                          right: 10,
                          textAlign: "center",
                          color: "#1e1e1e",
                          background: "rgb(255, 255, 255)",
                          borderRadius: "0.3rem"
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Image width='200' height='200' src={item.file ?? NoImage.src} alt={item.name} />
                    </span>
                  </Tooltip>
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
        <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
          <Typography variant='h4' fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
            <Link href='/merchant'>نمایش بیشتر ...</Link>
          </Typography>
        </Stack>
      </Box>
    )
  }
}

export async function getStaticProps(ctx) {
  const MerchantList = await axios.get("/api/v1/merchant/getMainMerchantList")
  return {
    props: {
      data: MerchantList.data
    }
  }
}
